export default __webpack_public_path__ + "static/media/multiple-sensor-chart.5ad606b1.svg";